<template>
  <div class="outer-container">
    <div class="container">
      <div class="row">
        <div class="col-6  left-heading">
          <img src="../../assets/chaldal/Chaldal-logo.png" alt="" style="display:none;" />
          <h2>
            A coding course <br />
            that
            <span class="stroke-pink"></span>
          </h2>
          <h5>
            Train remotely to become a full stack developer & <br />
            pay no tuition until you start getting PAID.
            <br /><br />
            Deadline for this Course has ended.<br> keep an eye out on our website and social media pages<br> for future ISA Programs.
          </h5>

          <a href="#chaldal" class="btn">
            Apply Now
          </a>

        </div>

        <div class="col-5  right-image">
          <img src="../../assets/chaldal/manupdated.png" alt="" />
        </div>
        <div class="col-1 right-image-social">
          <div class="flex">
            <a href="https://www.facebook.com/upskillbd/" target="_blank">
              <img
                class="left"
                src="../../assets/chaldal/Icon awesome-facebook-f.svg"
                alt=""
              />
            </a>
            <a
              href="https://www.linkedin.com/company/upskillbd/"
              target="_blank"
            >
              <img
                src="../../assets/chaldal/Icon awesome-linkedin-in.svg"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      class="container banner-bottom border-bottom "
      style="background-color:#FFC600;"
    >
      <h2>
        Steps to Success
      </h2>
      <div class="grid">
        <div>
          <h4>1</h4>
          <h3>
            Complete The Course
          </h3>
        </div>

        <div>
          <h4>2</h4>
          <h3>
            Get Certified
          </h3>
        </div>

        <div>
          <h4>3</h4>
          <h3>
            ENTER AN EXCLUSIVE POOL OF APPLICANTS
          </h3>
        </div>

        <div>
          <h4>4</h4>
          <h3>
            Proceed To Interview
          </h3>
        </div>

        <div>
          <h4>5</h4>
          <h3>
           Get Hired!
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {


};
</script>
<style scoped>
/* .stroke-pink {
  background-image: linear-gradient(#1e96fc, #1e96fc);
  background-position: 0 82%;
  background-size: 100% 18px;
  background-repeat: no-repeat;
} */

.container {
  max-width: 1300px !important;
}
.outer-container {
  background: transparent
    radial-gradient(closest-side at 64% 45%, #3238dc 0%, #132163 100%) 0% 0%
    no-repeat padding-box;
  opacity: 1;
}
.left-heading {
  padding-top: 65px;
  display: flex;

  flex-direction: column;
  justify-content: flex-end;
  max-height: 750px;
}

.left-heading span::before {
  padding-left: 15px;
  position:absolute;
  content: "PAYS YOU";
  animation-name: animate ;
  animation-duration: 6s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;

   -webkit-animation-name: animate;
 -webkit-animation-duration: 6s;
 -webkit-animation-iteration-count: infinite;
 -webkit-animation-timing-function: linear;


}
@keyframes animate {
  0% {
    content: "HIRES YOU";
  }
  20% {
    content: "EMPOWERS YOU";
  }
  40% {
    content: "ACCREDITS YOU";
  }
  60% {
    content: "PAYS YOU";
  }
  80% {
    content: "CERTIFIES YOU";
  }
  100% {
    content: "REWARDS YOU";
  }

}

@-o-keyframes animate {
  0% {
    content: "HIRES YOU";
  }
  20% {
    content: "EMPOWERS YOU";
  }
  40% {
    content: "ACCREDITS YOU";
  }
  60% {
    content: "PAYS YOU";
  }
  80% {
    content: "CERTIFIES YOU";
  }
  100% {
    content: "REWARDS YOU";
  }
}

@-moz-keyframes animate {
 0% {
    content: "HIRES YOU";
  }
  20% {
    content: "EMPOWERS YOU";
  }
  40% {
    content: "ACCREDITS YOU";
  }
  60% {
    content: "PAYS YOU";
  }
  80% {
    content: "CERTIFIES YOU";
  }
  100% {
    content: "REWARDS YOU";
  }
}
@-webkit-keyframes animate {
 0% {
    content: "HIRES YOU";
  }
  20% {
    content: "EMPOWERS YOU";
  }
  40% {
    content: "ACCREDITS YOU";
  }
  60% {
    content: "PAYS YOU";
  }
  80% {
    content: "CERTIFIES YOU";
  }
  100% {
    content: "REWARDS YOU";
  }
}

.left-heading img {
  max-width: 250px;
  max-height: 125px;
  margin-left: -25px;
}
.left-heading h2 {
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 50px;
  font-weight: 800;
  letter-spacing: -3px;
  line-height: 70px;
  color: white;
  padding-top: 10px;
}
.left-heading h6 {
  font-family: "Poppins";
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: white;
}
.left-heading h5 {
  font-family: "Poppins";
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: white;
  padding-top: 40px;
  padding-bottom: 35px;
}
.left-heading h2 span {
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 50px;
  font-weight: 800;
  letter-spacing: -3px;
  line-height: 70px;
  color: #ffc600;
}
.right-image {
  max-height: 750px;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
.right-image img {
  padding-top: 50px;

  max-height: 800px;
  display: flex;
  align-items: flex-end;
}
.right-image-social {
  display: flex;

  align-items: flex-end;
  margin-bottom: 100px;
}
.btn {
  background-color: white;
  text-align: center;
  max-width: 300px;
  height: 60px;
  border-radius: 0;
  margin-bottom: 90px;
  color: #181c2d;
  padding-top: 20px;
}
a {
  text-transform: capitalize;
  font-family: "Spartan";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #181c2d;
}
.banner-bottom {
  padding-top: 54px;
  padding-bottom: 50px;
  padding-left: 50px;
  padding-right: 50px;
}
.banner-bottom h2 {
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 7.2px;
  line-height: 24px;
  color: #00296b;
}
.grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
.grid h3 {
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: black;
}
.border-bottom h2 {
  border-bottom: 1px solid #304f64;
  padding-bottom: 15px;
}
.grid h4 {
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304f64;
  margin-top: 34px;
  margin-bottom: 15px;
}
.flex {
  display: inline-flex;
}
.flex .left {
  margin-right: 20px;
}
@media only screen and (min-width: 601px) and (max-width: 1100px) {
  a {
    color: black;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  .banner-bottom h2 {
    text-transform: uppercase;

    font-size: 16px;

    letter-spacing: 6.4px;
    line-height: 24px;
  }
  .banner-bottom {
    padding-top: 54px;
    padding-bottom: 50px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .right-image-social {
    display: none;
  }

  .left-heading img {
    max-width: 150px;
    max-height: 60px;
    margin-left: -15px;
  }
  .col-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-5 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .right-image img {
    margin-top: 100px;
    padding-top: 0px;
    max-width: 100%;
    max-height: 325px;
    display: flex;
    align-items: flex-end;
  }
  .left-heading h2 {
    font-size: 30px;

    letter-spacing: -1.5px;
    line-height: 35px;
  }
  .left-heading h2 span {
    font-size: 30px;

    letter-spacing: -1.5px;
    line-height: 35px;
  }
  .left-heading h5 {
    padding-top: 15px;
    padding-bottom: 25px;
  }
  .btn {
    text-align: center;
    max-width: 80%;
    height: 50px;
    border-radius: 0;
    margin-bottom: 15px;
    width: 100%;
  }
  /* .position input[type="radio"]:checked+label { font-weight: bold;
  border: 3px solid #FFC600;
  } */

  .left-heading {
    padding-top: 55px;
    display: flex;
    padding-left: 12px;
    padding-right: 12px;

    flex-direction: column;
    justify-content: flex-end;
    max-height: 750px;
  }
}
@media only screen and (max-width: 600px) {
  .left-heading span::before {
  padding-left: 10px;



}
  .grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
  .grid h4 {
    font-size: 20px;
    font-weight: 700;
  }
  .banner-bottom h2 {
    text-transform: uppercase;

    font-size: 16px;

    letter-spacing: 6.4px;
    line-height: 24px;
  }
  .banner-bottom {
    padding-top: 54px;
    padding-bottom: 50px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .right-image-social {
    display: none;
  }
  .row {
    display: flex;
    flex-direction: column;
  }
  .left-heading img {
    max-width: 150px;
    max-height: 60px;
    margin-left: -15px;
  }
  .col-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .col-5 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .right-image img {
    padding-top: 0px;
    max-width: 100%;
    max-height: 325px;
    display: flex;
    align-items: flex-end;
  }
  .left-heading h2 {
    font-size: 30px;

    letter-spacing: -1.5px;
    line-height: 35px;
  }
  .left-heading h2 span {
    font-size: 30px;

    letter-spacing: -1.5px;
    line-height: 35px;
  }
  .left-heading h5 {
    padding-top: 15px;
    padding-bottom: 25px;
  }
  .left-heading h5 {
    font-size: 18px;

    letter-spacing: 0px;
    line-height: 24px;
    color: white;
    padding-top: 10px;
    padding-bottom: 5px;
  }
  .btn {
    background-color: white;
    text-align: center;
    max-width: 100%;
    height: 60px;
    border-radius: 0;
    margin-bottom: 15px;
    width: 100%;
  }
  .outer-container {
    background: transparent
      radial-gradient(closest-side at 50% 63%, #3238dc 0%, #132163 100%) 0% 0%
      no-repeat padding-box;
    opacity: 1;
  }
  .left-heading {
    padding-top: 20px;
    display: flex;
    padding-left: 12px;
    padding-right: 12px;

    flex-direction: column;
    justify-content: flex-end;
    max-height: 750px;
  }
  /* .left-heading{
    width: 100%;
    order: 1;
  } */
}

@media only screen and (max-width: 372px) {
  .left-heading h2 {
    font-size: 24px;

    letter-spacing: -1.5px;
    line-height: 30px;
  }
  .left-heading h2 span {
    font-size: 24px;

    letter-spacing: -1.5px;
    line-height: 30px;
  }
  .left-heading h5 {
    font-size: 14px;

    letter-spacing: 0px;
    line-height: 24px;
    color: white;
    padding-top: 10px;
    padding-bottom: 5px;
  }

  .left-heading {
    padding-top: 5px;
  }
}
</style>
